export default "__VITE_ASSET__9b3bce45__"